import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import UploadNewTermsAndConditions from "./UploadNewTermsAndConditions";
import TermsAndConditionsHistory from "./TermsAndConditionsHistory";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";

function LoadTermsAndConditions(props) {
  useEffect(() => {
    props.loadTermsAndConditionsHistory();
  }, [props.loadTermsAndConditionsHistory]);

  return (
    <Grid container spacing={24}>
      <Grid item xs={12} md={12}>
        <HasPermissionTo
          permissions={props.user.permissions.rolePermissions}
          perform={["uploadNewTermsConditions:write"]}
          condition={!props.isDealer}
          render={() => <UploadNewTermsAndConditions {...props} />}
        />
        <TermsAndConditionsHistory {...props} />
      </Grid>
    </Grid>
  );
}

export default withTranslation("emp")(LoadTermsAndConditions);
